/** Schemas del panel Admin → Contenido Sitio */

const F = (fields) => ({ fields });
const L = (itemFields) => ({ type: "list", itemFields });

export const CONTENT_SCHEMAS = {
  "site.seo": {
    group: "Sitio general",
    label: "Titulo de la pagina (pestaña del navegador) y SEO",
    ...F([
      { key: "page_title", label: "Titulo de la pestaña del navegador", type: "text", hint: "Es el texto que ves en la pestaña del Chrome/Firefox, ej: L2 Aetheris — Interlude x10" },
      { key: "meta_description", label: "Descripcion SEO (Google)", type: "textarea" },
      { key: "og_title", label: "Titulo al compartir en redes (opcional, si vacio usa page_title)", type: "text" },
      { key: "og_description", label: "Descripcion al compartir (opcional)", type: "textarea" },
      { key: "og_image", label: "Imagen al compartir", type: "image", hint: "Subí una imagen o pegá una URL (ej: /og-image.jpg)" },
    ]),
  },
  "layout.brand": { group: "Layout global", label: "Logo / marca (navbar y footer)", ...F([
    { key: "name", label: "Nombre (ej: L2 AETHERIS)", type: "text" },
    { key: "tagline", label: "Subtitulo (ej: Interlude · Premium)", type: "text" },
  ])},
  "layout.topbar": { group: "Layout global", label: "Barra superior (franja de rates)", ...F([
    { key: "rates_line", label: "Texto de rates (derecha del online)", type: "text" },
  ])},
  "layout.vote_banners": { group: "Layout global", label: "Banners flotantes de voto / rankings", ...L([
    { key: "enabled", label: "Activo", type: "bool" },
    { key: "name", label: "Nombre interno", type: "text" },
    { key: "href", label: "URL de voto / destino", type: "text" },
    { key: "image", label: "Imagen / banner", type: "image" },
    { key: "alt", label: "Texto alt", type: "text" },
    { key: "title", label: "Texto al pasar el mouse", type: "text" },
    { key: "position", label: "Posicion (top-left | top-right | bottom-left | bottom-right)", type: "text" },
    { key: "width", label: "Ancho px", type: "text" },
    { key: "height", label: "Alto px", type: "text" },
    { key: "new_tab", label: "Abrir en nueva pestaña", type: "bool" },
  ])},

  "home.hero": { group: "Home", label: "Hero principal (titulos, CTAs, opening)", ...F([
    { key: "eyebrow", label: "Tag superior (eyebrow)", type: "text" },
    {
      key: "logo_url",
      label: "Logo del hero (reemplaza los titulos)",
      type: "image",
      hint: "Si subís un logo, se muestra en lugar de \"Titulo linea 1 / linea 2\". Dejá vacio para usar los textos.",
    },
    { key: "logo_max_height", label: "Alto max del logo (px, ej: 180)", type: "text", hint: "Solo aplica si hay logo. Default 180." },
    { key: "title_1", label: "Titulo linea 1 (si no hay logo)", type: "text" },
    { key: "title_2", label: "Titulo linea 2 dorado (si no hay logo)", type: "text" },
    { key: "subtitle", label: "Subtitulo", type: "textarea" },
    { key: "opening_label", label: "Etiqueta countdown (ej: Grand Opening)", type: "text" },
    { key: "opening_date_text", label: "Fecha visible (ej: 15 Ago 2025 · 21:00 GMT)", type: "text" },
    {
      key: "opening_iso",
      label: "Countdown — fecha/hora real del OPEN (formato ISO UTC)",
      type: "text",
      hint: "Ej: 2026-03-15T21:00:00Z = 15 Mar 2026 21:00 UTC. En Argentina (UTC-3) seria 18:00 hora local → usa 2026-03-15T21:00:00Z si el open es 18:00 ARG. Siempre termina en Z (UTC).",
    },
    // --- Estilo del countdown (cajas) ---
    { key: "cd_digit_color", label: "Countdown · color de los numeros", type: "text", hint: "Ej: #d4a843 o #ffffff" },
    { key: "cd_label_color", label: "Countdown · color de etiquetas (Dias/Horas…)", type: "text", hint: "Ej: #8a8a92" },
    { key: "cd_bg", label: "Countdown · fondo de cada caja", type: "text", hint: "Ej: rgba(17,17,24,0.75) o #111118" },
    { key: "cd_border_color", label: "Countdown · color del marco", type: "text", hint: "Ej: rgba(212,168,67,0.35) o #d4a843" },
    { key: "cd_border_width", label: "Countdown · grosor del marco (px)", type: "text", hint: "Ej: 1 · 0 = sin marco" },
    {
      key: "cd_radius",
      label: "Countdown · forma / redondeo (px)",
      type: "text",
      hint: "0 = cuadrado · 6 = suave · 16 = redondeado · 999 = circulo/pill",
    },
    { key: "cd_shadow", label: "Countdown · sombra CSS (opcional)", type: "text", hint: "Ej: 0 8px 24px rgba(0,0,0,0.45) · vacio = sin sombra extra" },
    { key: "cd_shimmer", label: "Countdown · brillo animado (shimmer)", type: "bool" },
    // --- Estilo de la fecha visible ---
    { key: "date_color", label: "Fecha · color del texto", type: "text", hint: "Ej: #8a8a92 o #f0ebe0" },
    { key: "date_icon_color", label: "Fecha · color del icono calendario", type: "text", hint: "Ej: #d4a843" },
    { key: "date_bg", label: "Fecha · fondo (opcional)", type: "text", hint: "Vacio = transparente. Ej: rgba(0,0,0,0.45) o #1a1610" },
    { key: "date_border_color", label: "Fecha · color del marco (opcional)", type: "text" },
    { key: "date_border_width", label: "Fecha · grosor del marco (px)", type: "text", hint: "0 o vacio = sin marco" },
    { key: "date_radius", label: "Fecha · redondeo (px)", type: "text", hint: "Ej: 4 · 999 = pill" },
    { key: "date_padding", label: "Fecha · padding CSS", type: "text", hint: "Ej: 8px 16px · vacio = sin caja" },
    { key: "cta_primary_text", label: "Boton primario (texto)", type: "text" },
    { key: "cta_primary_link", label: "Boton primario (URL)", type: "text" },
    { key: "cta_secondary_text", label: "Boton secundario (texto)", type: "text" },
    { key: "cta_secondary_link", label: "Boton secundario (URL)", type: "text" },
  ])},
  "home.server_info": { group: "Home", label: "Encabezado mini Server Info (debajo de caracteristicas)", ...F([
    { key: "eyebrow", label: "Tag", type: "text" },
    { key: "title", label: "Titulo", type: "text" },
    { key: "subtitle", label: "Subtitulo", type: "textarea" },
  ])},
  "home.sections": { group: "Home", label: "Mostrar / ocultar secciones en Home", ...F([
    { key: "features", label: "Caracteristicas unicas", type: "bool" },
    { key: "server_info", label: "Mini Server Info (usa mismos datos que Wiki)", type: "bool" },
    { key: "news", label: "Cronicas del reino (noticias)", type: "bool" },
    { key: "votes", label: "Votos", type: "bool" },
    { key: "roadmap", label: "Roadmap", type: "bool" },
    { key: "faq", label: "FAQ (desactivar = no se muestra)", type: "bool" },
  ])},
  "home.features_header": { group: "Home", label: "Encabezado — Caracteristicas", ...F([
    { key: "eyebrow", label: "Tag", type: "text" },
    { key: "title", label: "Titulo", type: "text" },
    { key: "subtitle", label: "Descripcion", type: "textarea" },
  ])},
  "home.features": { group: "Home", label: "Lista de caracteristicas (agregar / quitar / editar)", ...L([
    { key: "id", label: "ID numero", type: "text" },
    { key: "icon", label: "Icono (Layers|Sparkles|Gift|Swords|ShieldCheck|Crown)", type: "text" },
    { key: "title", label: "Titulo", type: "text" },
    { key: "description", label: "Descripcion", type: "textarea" },
    { key: "image", label: "Imagen", type: "image" },
  ])},
  "home.news_header": { group: "Home · Noticias", label: "Encabezado bloque noticias en Home", ...F([
    { key: "eyebrow", label: "Tag", type: "text" },
    { key: "title", label: "Titulo", type: "text" },
  ])},
  "news.list": { group: "Noticias", label: "Todas las noticias (Home + pagina /news)", ...L([
    { key: "id", label: "ID unico", type: "text" },
    { key: "date", label: "Fecha (YYYY-MM-DD)", type: "text" },
    { key: "category", label: "Categoria", type: "text" },
    { key: "title", label: "Titulo", type: "text" },
    { key: "excerpt", label: "Resumen", type: "textarea" },
    { key: "image", label: "Imagen", type: "image" },
    { key: "pinned", label: "Destacada (pinned)", type: "bool" },
  ])},
  "news.page_header": { group: "Noticias", label: "Encabezado pagina /news", ...F([
    { key: "eyebrow", label: "Tag", type: "text" },
    { key: "title", label: "Titulo", type: "text" },
    { key: "subtitle", label: "Subtitulo", type: "textarea" },
  ])},
  "home.votes_header": { group: "Home · Votos", label: "Encabezado seccion votos", ...F([
    { key: "eyebrow", label: "Tag", type: "text" },
    { key: "title", label: "Titulo", type: "text" },
    { key: "description", label: "Descripcion", type: "textarea" },
  ])},
  "home.votes_stats": { group: "Home · Votos", label: "Mini stats (3 cajas)", ...L([
    { key: "label", label: "Valor grande", type: "text" },
    { key: "sub", label: "Texto inferior", type: "text" },
  ])},
  "home.votes_sites": { group: "Home · Votos", label: "Sitios de votacion", ...L([
    { key: "id", label: "ID", type: "text" },
    { key: "name", label: "Nombre", type: "text" },
    { key: "url", label: "URL", type: "text" },
    { key: "reward", label: "Recompensa", type: "text" },
    { key: "cooldown", label: "Cooldown", type: "text" },
    { key: "logo", label: "Letra logo (1 char)", type: "text" },
  ])},
  "home.roadmap_header": { group: "Home · Roadmap", label: "Encabezado roadmap", ...F([
    { key: "eyebrow", label: "Tag (opcional, vacio = Camino del Heroe)", type: "text" },
    { key: "title", label: "Titulo", type: "text" },
    { key: "subtitle", label: "Subtitulo (opcional)", type: "textarea" },
  ])},
  "home.roadmap": { group: "Home · Roadmap", label: "Fases del roadmap", ...L([
    { key: "phase", label: "Nombre fase", type: "text" },
    { key: "date", label: "Fecha texto", type: "text" },
    { key: "status", label: "Estado (completed|active|upcoming|planned)", type: "text" },
    { key: "items", label: "Items (JSON array de strings)", type: "json" },
  ])},
  "home.faq_header": { group: "Home · FAQ", label: "Encabezado FAQ", ...F([
    { key: "eyebrow", label: "Tag", type: "text" },
    { key: "title", label: "Titulo", type: "text" },
  ])},
  "home.faq": { group: "Home · FAQ", label: "Preguntas (vaciar lista = sin preguntas)", ...L([
    { key: "q", label: "Pregunta", type: "text" },
    { key: "a", label: "Respuesta", type: "textarea" },
  ])},

  "wiki.tabs": {
    group: "Wiki",
    label: "Pestañas Wiki / Server Info (agregar, quitar, reordenar)",
    type: "list",
    itemFields: [
      { key: "id", label: "ID unico (slug, sin espacios: olympiad, farm, siege)", type: "text" },
      { key: "label", label: "Nombre en el menu", type: "text" },
      { key: "icon", label: "Icono Lucide (Coins, Trophy, Castle, Pickaxe, Swords, Crown...)", type: "text" },
      {
        key: "kind",
        label: "Tipo de contenido",
        type: "select",
        options: [
          { value: "markdown", label: "Texto libre (Markdown) — escribes en \"Contenido Markdown\" abajo" },
          { value: "cards", label: "Tarjetas con imagen — Items JSON (+ texto opcional en Markdown arriba)" },
          { value: "steps", label: "Pasos numerados — Items JSON (+ texto opcional en Markdown arriba)" },
          { value: "simple_list", label: "Lista simple (nombre + valor) — Items JSON (+ texto opcional en Markdown arriba)" },
          { value: "rates", label: "Rates (datos del bloque Wiki · Rates)" },
          { value: "enchant", label: "Enchant (datos del bloque Wiki · Enchant)" },
          { value: "classes", label: "Clases (datos del bloque Wiki · Clases)" },
          { value: "npc", label: "NPCs (datos del bloque Wiki · NPCs)" },
          { value: "events", label: "Eventos (datos del bloque Wiki · Eventos)" },
          { value: "guide", label: "Guía (datos del bloque Wiki · Guía)" },
        ],
        hint: "Para una pestaña NUEVA y propia (ej: Random Zone) elegí \"Texto libre (Markdown)\" y escribí en el campo de abajo. Los tipos rates/enchant/etc. solo repiten datos que ya existen en otros bloques.",
      },
      { key: "section_title", label: "Titulo dentro de la pestaña", type: "text" },
      { key: "section_subtitle", label: "Subtitulo", type: "textarea" },
      { key: "body", label: "Contenido Markdown (tipo Markdown, o como texto/intro arriba de Tarjetas, Pasos y Lista simple)", type: "markdown" },
      {
        key: "items",
        label: "Items JSON (si elegiste tipo = Tarjetas, Pasos o Lista simple)",
        type: "json",
        hint: 'Tarjetas: [{"title":"...","description":"...","image":"url","image_fit":"contain","image_height":250}]. image_fit: "contain" = imagen completa achicada (default), "cover" = rellena y recorta. image_height/image_width opcionales (ej: 250 o "60%"). Click en la imagen la abre en tamaño real. Pasos: [{"step":"01","title":"...","text":"..."}]. Lista simple: [{"title":"...","value":"..."}]',
      },
    ],
  },
  "wiki.header": { group: "Wiki", label: "Encabezado pagina Wiki", ...F([
    { key: "eyebrow", label: "Tag", type: "text" },
    { key: "title", label: "Titulo", type: "text" },
    { key: "subtitle", label: "Subtitulo", type: "textarea" },
  ])},
  "wiki.rates": { group: "Wiki · Rates", label: "Rates del servidor", ...L([
    { key: "label", label: "Nombre", type: "text" },
    { key: "value", label: "Valor (ej: x10)", type: "text" },
  ])},
  "wiki.enchant_rates": { group: "Wiki · Enchant", label: "Tabla enchant", ...L([
    { key: "type", label: "Tipo scroll", type: "text" },
    { key: "safe", label: "Safe", type: "text" },
    { key: "max", label: "Max", type: "text" },
    { key: "rate", label: "Tasa", type: "text" },
  ])},
  "wiki.classes": { group: "Wiki · Clases", label: "Clases y subclases", ...L([
    { key: "name", label: "Nombre", type: "text" },
    { key: "role", label: "Rol", type: "text" },
    { key: "description", label: "Descripcion", type: "textarea" },
    { key: "image", label: "Imagen", type: "image" },
    { key: "color", label: "Color hex (#d4a843)", type: "text" },
    { key: "subclasses", label: "Subclases (JSON array)", type: "json" },
  ])},
  "wiki.npcs": { group: "Wiki · NPCs", label: "NPCs custom", ...L([
    { key: "name", label: "Nombre", type: "text" },
    { key: "description", label: "Descripcion", type: "textarea" },
    { key: "icon", label: "Icono (Sparkles|MapPin|...)", type: "text" },
  ])},
  "wiki.events": { group: "Wiki · Eventos", label: "Calendario eventos", ...L([
    { key: "time", label: "Hora", type: "text" },
    { key: "name", label: "Nombre", type: "text" },
    { key: "duration", label: "Duracion", type: "text" },
    { key: "reward", label: "Reward", type: "text" },
  ])},
  "wiki.guide_steps": { group: "Wiki · Guia", label: "Pasos guia de inicio", ...L([
    { key: "step", label: "Numero", type: "text" },
    { key: "title", label: "Titulo", type: "text" },
    { key: "text", label: "Texto", type: "textarea" },
  ])},
  "wiki.sections": { group: "Wiki", label: "Secciones extra (markdown al final)", ...L([
    { key: "id", label: "ID slug", type: "text" },
    { key: "title", label: "Titulo", type: "text" },
    { key: "body", label: "Cuerpo Markdown", type: "markdown" },
  ])},

  "downloads.intro": { group: "Descargas", label: "Intro (Markdown)", type: "markdown" },
  "downloads.list": { group: "Descargas", label: "Lista de descargas", ...L([
    { key: "name", label: "Nombre", type: "text" },
    { key: "url", label: "URL", type: "text" },
    { key: "size", label: "Tamano", type: "text" },
    { key: "type", label: "Tipo", type: "text" },
    { key: "description", label: "Descripcion", type: "textarea" },
  ])},
  "nav.items": { group: "Navegacion", label: "Menu principal", ...L([
    { key: "label", label: "Etiqueta", type: "text" },
    { key: "url", label: "URL", type: "text" },
    { key: "external", label: "Link externo", type: "bool" },
  ])},
  "footer.brand": { group: "Footer", label: "Marca en footer", ...F([
    { key: "name", label: "Nombre", type: "text" },
    { key: "tagline", label: "Tagline", type: "text" },
  ])},
  "footer.about": { group: "Footer", label: "Texto About", type: "textarea" },
  "footer.copyright": { group: "Footer", label: "Copyright", type: "text" },
  "footer.social": { group: "Footer", label: "Redes sociales", ...L([
    { key: "platform", label: "Plataforma", type: "text" },
    { key: "url", label: "URL", type: "text" },
  ])},
  "theme.branding": { group: "Apariencia / Tema", label: "Logo, fondos y colores del sitio", ...F([
    { key: "logo_url", label: "Logo del servidor (navbar)", type: "image", hint: "PNG/JPG, cuadrado recomendado. Se usa en la barra superior." },
    { key: "favicon_url", label: "Favicon", type: "image" },
    { key: "color_gold", label: "Color dorado principal (#d4a843)", type: "text" },
    { key: "color_gold_light", label: "Dorado claro / hover (#f5c542)", type: "text" },
    { key: "color_gold_dark", label: "Dorado oscuro (#8b6914)", type: "text" },
    { key: "color_text", label: "Texto principal (#f0ebe0)", type: "text" },
    { key: "color_muted", label: "Texto secundario (#b8b3a8)", type: "text" },
    { key: "color_bg", label: "Fondo pagina (#0a0a0d)", type: "text" },
    { key: "bg_hero", label: "Imagen fondo HERO", type: "image" },
    {
      key: "bg_hero_overlay",
      label: "Oscuridad del fondo HERO (0–100)",
      type: "text",
      hint: "0 = se ve la imagen clara · 50 = equilibrado · 100 = casi negro. Antes era ~85 (muy oscuro). Probá 45–60.",
    },
    { key: "bg_wiki", label: "Imagen fondo Wiki / Server Info", type: "image" },
    { key: "bg_news", label: "Imagen fondo pagina Noticias", type: "image" },
    { key: "bg_server_info", label: "Fondo mini Server Info en Home (opcional, si vacio usa bg_wiki)", type: "image" },
    {
      key: "bg_sections_opacity",
      label: "Visibilidad fondo Wiki/News (0–100)",
      type: "text",
      hint: "Que tan visible es la imagen de fondo en headers de Wiki y Noticias. Default 20.",
    },
  ])},
  "footer.columns": { group: "Footer", label: "Columnas de links", ...L([
    { key: "title", label: "Titulo columna", type: "text" },
    { key: "links", label: "Links [{label,url}]", type: "json" },
  ])},

  "legal.pages": { group: "Paginas legales / info", label: "Paginas (Terminos, Privacidad, Reglas, etc.)", ...L([
    { key: "slug", label: "Slug / URL (ej: terms → /p/terms)", type: "text", hint: "Solo letras minusculas, sin espacios. Es la direccion de la pagina." },
    { key: "title", label: "Titulo de la pagina", type: "text" },
    { key: "footer_label", label: "Nombre en el footer (opcional, si vacio usa el titulo)", type: "text" },
    { key: "eyebrow", label: "Tag superior (opcional)", type: "text" },
    { key: "show_in_footer", label: "Mostrar enlace en el footer", type: "bool" },
    { key: "body", label: "Contenido (Markdown: ## titulos, **negrita**, - listas, [link](url))", type: "markdown" },
  ])},
  "account.panel": { group: "Panel de Cuenta", label: "Textos del panel de cuenta", ...F([
    { key: "eyebrow", label: "Tag superior", type: "text" },
    { key: "stat_characters", label: "Tarjeta: Personajes", type: "text" },
    { key: "stat_coins", label: "Tarjeta: Donate Coins", type: "text" },
    { key: "stat_orders", label: "Tarjeta: Donaciones", type: "text" },
    { key: "stat_access", label: "Tarjeta: Acceso", type: "text" },
    { key: "donate_cta_title", label: "Boton donar — titulo", type: "text" },
    { key: "donate_cta_text", label: "Boton donar — descripcion", type: "textarea" },
    { key: "banner_ok_title", label: "Aviso pago OK — titulo", type: "text" },
    { key: "banner_ok_msg", label: "Aviso pago OK — mensaje", type: "textarea" },
    { key: "banner_fail_title", label: "Aviso pago rechazado — titulo", type: "text" },
    { key: "banner_fail_msg", label: "Aviso pago rechazado — mensaje (usa {order} para el numero de orden)", type: "textarea" },
    { key: "banner_pending_title", label: "Aviso pago pendiente — titulo", type: "text" },
    { key: "banner_pending_msg", label: "Aviso pago pendiente — mensaje", type: "textarea" },
    { key: "characters_title", label: "Titulo seccion personajes", type: "text" },
    { key: "characters_empty", label: "Texto si no hay personajes", type: "text" },
    { key: "history_title", label: "Titulo historial de donaciones", type: "text" },
    { key: "history_empty", label: "Texto si no hay donaciones", type: "text" },
  ])},
  "donate.config": { group: "Panel de Cuenta", label: "Donaciones — metodos, textos y tasas (coins)", ...F([
    { key: "product_name", label: "Texto que ve el jugador al pagar (ej: L2 Aetheris - Donate Coins)", type: "text", hint: "Aparece en PayPal, MercadoPago, Khipu y crypto como concepto del pago." },
    { key: "brand_name", label: "Nombre de marca (PayPal y resumen de tarjeta, max 22 car.)", type: "text" },
    { key: "method_paypal", label: "Mostrar PayPal", type: "bool" },
    { key: "method_mp_ar", label: "Mostrar MercadoPago Argentina", type: "bool" },
    { key: "method_mp_cl", label: "Mostrar MercadoPago Chile", type: "bool" },
    { key: "method_khipu_cl", label: "Mostrar Khipu Chile", type: "bool" },
    { key: "method_khipu_ar", label: "Mostrar Khipu Argentina", type: "bool" },
    { key: "method_flow_cl", label: "Mostrar Flow Chile", type: "bool" },
    { key: "method_dlocal_go", label: "Mostrar dLocal Go (internacional USD)", type: "bool" },
    { key: "method_paymentwall", label: "Mostrar Paymentwall (internacional USD)", type: "bool" },
    { key: "method_crypto", label: "Mostrar USDT (Crypto)", type: "bool" },

    { key: "name_paypal", label: "PayPal — nombre visible", type: "text", hint: "Texto del boton en la pagina de donaciones." },
    { key: "desc_paypal", label: "PayPal — descripcion", type: "text" },
    { key: "name_mp_ar", label: "MercadoPago AR — nombre visible", type: "text" },
    { key: "desc_mp_ar", label: "MercadoPago AR — descripcion", type: "text" },
    { key: "name_mp_cl", label: "MercadoPago CL — nombre visible", type: "text" },
    { key: "desc_mp_cl", label: "MercadoPago CL — descripcion", type: "text" },
    { key: "name_khipu_cl", label: "Khipu Chile — nombre visible", type: "text" },
    { key: "desc_khipu_cl", label: "Khipu Chile — descripcion", type: "text" },
    { key: "name_khipu_ar", label: "Khipu Argentina — nombre visible", type: "text" },
    { key: "desc_khipu_ar", label: "Khipu Argentina — descripcion", type: "text" },
    { key: "name_flow_cl", label: "Flow Chile — nombre visible", type: "text", hint: "Ej: Flow, Flow Tarjetas, Flow Internacional..." },
    { key: "desc_flow_cl", label: "Flow Chile — descripcion", type: "text" },
    { key: "name_dlocal_go", label: "dLocal Go — nombre visible", type: "text", hint: "Ej: dLocal, Pagos internacionales..." },
    { key: "desc_dlocal_go", label: "dLocal Go — descripcion", type: "text" },
    { key: "name_paymentwall", label: "Paymentwall — nombre visible", type: "text", hint: "Ej: Paymentwall, Pagos globales..." },
    { key: "desc_paymentwall", label: "Paymentwall — descripcion", type: "text" },
    { key: "name_crypto", label: "USDT (Crypto) — nombre visible", type: "text" },
    { key: "desc_crypto", label: "USDT (Crypto) — descripcion", type: "text" },

    // Tasas de conversion (editables)
    {
      key: "rate_usd_amount",
      label: "Tasa USD (PayPal / dLocal / Paymentwall) — cada cuantos USD",
      type: "text",
      hint: "Ej: 1  → significa “cada 1 USD…”",
    },
    {
      key: "rate_usd_coins",
      label: "Tasa USD — cuantas Donate Coins",
      type: "text",
      hint: "Ej: 1500  → cada 1 USD = 1500 coins. Cambiá a 1000, 1700, 2000, etc.",
    },
    {
      key: "rate_usdt_amount",
      label: "Tasa USDT (Crypto) — cada cuantos USDT",
      type: "text",
      hint: "Ej: 1",
    },
    {
      key: "rate_usdt_coins",
      label: "Tasa USDT (Crypto) — cuantas Donate Coins",
      type: "text",
      hint: "Ej: 1500. Puede ser distinta a PayPal si querés.",
    },
    {
      key: "rate_ars_amount",
      label: "Tasa ARS (Argentina) — cada cuantos pesos",
      type: "text",
      hint: "Ej: 100  → “cada 100 ARS…” · o 1 si querés 1 peso = N coins",
    },
    {
      key: "rate_ars_coins",
      label: "Tasa ARS — cuantas Donate Coins",
      type: "text",
      hint: "Ej: 1 con amount 100 = 1 coin cada 100 pesos. O amount 1 + coins 1 = 1:1",
    },
    {
      key: "rate_clp_amount",
      label: "Tasa CLP (Chile / Flow) — cada cuantos pesos",
      type: "text",
      hint: "Ej: 1000",
    },
    {
      key: "rate_clp_coins",
      label: "Tasa CLP — cuantas Donate Coins",
      type: "text",
      hint: "Ej: 1500  → cada 1000 CLP = 1500 coins",
    },
  ])},
  "account.backup": { group: "Panel de Cuenta", label: "TXT de respaldo al crear/recuperar cuenta", ...F([
    { key: "file_title", label: "Titulo del archivo TXT (linea central del encabezado)", type: "text", hint: "Ej: MI SERVIDOR - CUENTA" },
    { key: "filename_prefix", label: "Prefijo del nombre del archivo descargado", type: "text", hint: "Ej: cuenta → cuenta_register_usuario_123.txt" },
    { key: "intro_register", label: "Mensaje al registrarse", type: "textarea" },
    { key: "intro_recover", label: "Mensaje al recuperar password", type: "textarea" },
    { key: "intro_change", label: "Mensaje al cambiar password", type: "textarea" },
    { key: "instructions", label: "Instrucciones (una linea por punto, se muestran tal cual)", type: "textarea" },
    { key: "server_label", label: "Etiqueta servidor (ej: Servidor:)", type: "text" },
    { key: "server_url", label: "URL o dominio del servidor", type: "text", hint: "Ej: l2iris.com o https://midominio.com" },
    { key: "support_label", label: "Etiqueta soporte (ej: Soporte:)", type: "text" },
    { key: "support_contact", label: "Contacto de soporte (Discord, email, etc.)", type: "text", hint: "Ej: https://discord.gg/KCbBprh7Bk" },
  ])},
  "account.donate": { group: "Panel de Cuenta", label: "Textos de la pagina de donaciones", ...F([
    { key: "eyebrow", label: "Tag superior", type: "text" },
    { key: "title", label: "Titulo principal (ej: Apoya al Servidor)", type: "text" },
    { key: "method_title", label: "Paso 1 — titulo (Metodo de pago)", type: "text" },
    { key: "amount_title", label: "Paso 2 — titulo (Monto)", type: "text" },
    { key: "email_title", label: "Paso email — titulo", type: "text" },
    { key: "email_note", label: "Paso email — nota", type: "textarea" },
    { key: "security_note", label: "Nota de seguridad (usa {method} para el metodo elegido)", type: "textarea" },
  ])},
};
